import isArray from "lodash/isArray";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import snakeCase from "lodash/snakeCase";
import api from "PFCore/api";
import { Collection, Id } from "PFTypes";
import { FilterKeyV2, FilterOptionV2 } from "PFTypes/filters_v2";

export type FetchFilterOptionsParams = {
  searchId?: Id;
  name: FilterKeyV2;
  term?: string;
  value?: string;
  isChildren?: boolean;
};

export type FetchFilterOptionsResponse = Collection<FilterOptionV2[], { selectedOptionsLimit?: number }>;

export const fetchFilterOptions = ({ searchId, name, term, value, isChildren }: FetchFilterOptionsParams) =>
  api<FetchFilterOptionsResponse | FilterOptionV2[]>({
    url: "options/filters",
    method: "GET",
    params: {
      searchId,
      name: snakeCase(name),
      ...(isEmpty(term) ? {} : { term }),
      ...(value || ((isArray(value) || isObject(value)) && !isEmpty(value)) ? { value } : {}),
      ...(!isChildren ? {} : { children: true })
    }
  }).then((optionsListOrCollection) => {
    if (isArray(optionsListOrCollection)) {
      return { entries: optionsListOrCollection, meta: { total: optionsListOrCollection.length } };
    }

    return optionsListOrCollection;
  });
